import { API_URL, SITE_ID } from "./config";
import axios from "axios";

export const getAllHouseholds = (callback) => {
  axios
    .get(`${API_URL}/api/household_data/get_all/${SITE_ID}`)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {});
};

export const getSummary = (callback) => {
  axios
    .get(`${API_URL}/api/household_data/get_summary/${SITE_ID}`)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {});
};

export const getPregnant = (callback) => {
  axios
    .get(`${API_URL}/api/household_data/get_pregnant`)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {});
};

export const getComorbid = (callback) => {
  axios
    .get(`${API_URL}/api/household_data/get_comorbidity`)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {});
};

export const getDisabled = (callback) => {
  axios
    .get(`${API_URL}/api/household_data/get_disability`)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {});
};

export const getSenior = (callback) => {
  axios
    .get(`${API_URL}/api/household_data/get_seniors`)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {});
};

export const getChildren = (callback) => {
  axios
    .get(`${API_URL}/api/household_data/get_children`)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {});
};

export const getToddler = (callback) => {
  axios
    .get(`${API_URL}/api/household_data/get_toddlers`)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {});
};

export const addHousehold = (data, callback) => {
  axios
    .post(`${API_URL}/api/household_data/add`, data)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {});
};

export const editHousehold = (data, callback) => {
  axios
    .patch(`${API_URL}/api/household_data/update`, data)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {});
};

export const deleteHousehold = (submitData, callback) => {
  axios
    .delete(`${API_URL}/api/household_data/delete`, { data: submitData })
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {});
};
